import { Box, CircularProgress, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNewFaxLoadingViewStyle } from '~/pages/Home/Modals/NewFaxModal/componentStyles/NewFaxLoadingView.style'
import { textStyleKeys } from '~/themes/textStyles'

interface NewFaxLoadingViewProps {
  progress: number
}

export const NewFaxLoadingView = ({ progress }: NewFaxLoadingViewProps) => {
  const styles = useNewFaxLoadingViewStyle()
  const { t } = useTranslation()
  return (
    <Box as={VStack} sx={styles.container}>
      <CircularProgress
        size={styles.circularProgress.height!.toString()}
        thickness={styles.circularProgress.width!.toString()}
        capIsRound
        color={styles.circularProgress.color!.toString()}
        trackColor={styles.circularProgress.backgroundColor!.toString()}
        isIndeterminate={!progress}
        value={progress}
      />
      <Text textStyle={textStyleKeys.H6}>
        {t('newFaxModal.loadingView.sendingFax')}
      </Text>
    </Box>
  )
}
